// TEMP DEBUG: per-model pricing (USD per 1M tokens), used for the running
// token/cost readout in the chat header and the debug panel. Remove alongside
// those once debugging is done. Cache writes (5m TTL, which is what we use)
// cost 1.25x the input price; cache reads cost 0.1x.
const MODEL_PRICING = {
  "claude-sonnet-5": { input: 2.0, output: 10.0 }, // intro pricing through 2026-08-31
  "claude-opus-4-8": { input: 5.0, output: 25.0 },
  "claude-haiku-4-5": { input: 1.0, output: 5.0 },
};

export function getPricingForModel(model) {
  const key = Object.keys(MODEL_PRICING).find((k) => model?.startsWith(k));
  return key ? MODEL_PRICING[key] : null;
}

export function computeTurnCost(usage, model) {
  const pricing = getPricingForModel(model);
  if (!pricing || !usage) return 0;
  const inputCost = (usage.input_tokens || 0) * pricing.input;
  const cacheWriteCost = (usage.cache_creation_input_tokens || 0) * pricing.input * 1.25;
  const cacheReadCost = (usage.cache_read_input_tokens || 0) * pricing.input * 0.1;
  const outputCost = (usage.output_tokens || 0) * pricing.output;
  return (inputCost + cacheWriteCost + cacheReadCost + outputCost) / 1_000_000;
}

export function countTurnTokens(usage) {
  if (!usage) return 0;
  return (
    (usage.input_tokens || 0) +
    (usage.output_tokens || 0) +
    (usage.cache_creation_input_tokens || 0) +
    (usage.cache_read_input_tokens || 0)
  );
}
